import React, { useEffect } from "react";
import { db } from "../FirebaseConfig"; // Firestore config
import {
  addDoc,
  collection,
  doc,
  increment,
  serverTimestamp,
  Timestamp,
  updateDoc,
} from "firebase/firestore";

function UpdateLastLogin({ userID }) {
  useEffect(() => {
    const updateLastLogin = async () => {
      try {
        const lastLoginCollectionRef = collection(db, "lastLogin");

        // Create a new document in lastLogin with userID and timestamp
        await addDoc(lastLoginCollectionRef, {
          userId: userID,
          timestamp: Timestamp.now(),
        });

        // console.log(`Logged last login timestamp for user ${userID}`);

        // Add login activity to user's subcollection
        const userLoginRef = collection(db, "users", userID, "loginActivity");
        await addDoc(userLoginRef, { timestamp: serverTimestamp() });

        // Increment loginCount in user document
        const userRef = doc(db, "users", userID);
        await updateDoc(userRef, { loginCount: increment(1) });
      } catch (error) {
        console.error("Error updating last login:", error);
      }
    };

    if (userID) {
      updateLastLogin();
    }
  }, [userID]);

  return null; // No UI needed for this utility function
}

export default UpdateLastLogin;
